import { render, staticRenderFns } from "./OrgSimple.vue?vue&type=template&id=5de65db0&"
import script from "./OrgSimple.vue?vue&type=script&lang=js&"
export * from "./OrgSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports